/**
 * Unsaved filter / sort changes per saved view, kept for this browser tab only
 * (sessionStorage): they survive moving around the app and are gone when the
 * tab closes or the user logs out, so a view then opens as saved. Storage can
 * be unavailable (private mode, blocked site data); every access is guarded and
 * the views simply don't remember edits then.
 */
const PREFIX = "savedViewDraft:"

export function savedViewDraftKey(page, accountId, viewKey) {
  return `${PREFIX}${page}:${accountId ?? "me"}:${viewKey}`
}

export function readSavedViewDraft(key) {
  try {
    const raw = window.sessionStorage.getItem(key)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function writeSavedViewDraft(key, draft) {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(draft))
  } catch {
    // Storage full or blocked: the edit still applies, it just isn't remembered.
  }
}

export function removeSavedViewDraft(key) {
  try {
    window.sessionStorage.removeItem(key)
  } catch {
    // Nothing to clean up without storage.
  }
}

export function clearSavedViewDrafts() {
  try {
    const keys = []
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key && key.startsWith(PREFIX)) {
        keys.push(key)
      }
    }
    keys.forEach((key) => window.sessionStorage.removeItem(key))
  } catch {
    // Nothing to clean up without storage.
  }
}
